import styled from 'styled-components'
import Videos from '../../../shared/Videos'

export const BgImg = styled.img`
  position: absolute;
  top: 0;
  left: 0;
  z-index: -1;
  height: 100%;
  object-fit: cover;
  object-position: 50% 50%;

  @media screen and (min-width: ${props => props.theme.responsive.large}) {
    object-fit: fill;
  }

  // @media screen and (max-width: ${props => props.theme.responsive.small}) {
  //   padding: 25px;
  // }
`

export const BgImgContainer = styled.div`
  &::before {
    content: '';
    background: rgba(0, 0, 0, 0.3);
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    height: 100%;
    width: 100%;
    z-index: 1;
  }
`

export const BgVideo = styled(Videos)`
  position: absolute;
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: 50% 50%; 
  margin-left: auto;
  margin-right: auto;
  left: 0;
  right: 0;
  bottom: 0;
  max-width: 800px;
  -webkit-animation: fadein 15s; /* Safari, Chrome and Opera > 12.1 */
  -moz-animation: fadein 15s; /* Firefox < 16 */
  -ms-animation: fadein 15s; /* Internet Explorer */
  -o-animation: fadein 15s; /* Opera < 12.1 */
  animation: fadein 15s;

@keyframes fadein {
    from { opacity: 0; }
    to   { opacity: 1; }
}

/* Firefox < 16 */
@-moz-keyframes fadein {
    from { opacity: 0; }
    to   { opacity: 1; }
}

/* Safari, Chrome and Opera > 12.1 */
@-webkit-keyframes fadein {
    from { opacity: 0; }
    to   { opacity: 1; }
}

/* Internet Explorer */
@-ms-keyframes fadein {
    from { opacity: 0; }
    to   { opacity: 1; }
}

/* Opera < 12.1 */
@-o-keyframes fadein {
    from { opacity: 0; }
    to   { opacity: 1; }
}
`
export const VideoWrapper = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: 50% 50%; 
  margin-left: auto;
  margin-right: auto;
  left: 0;
  right: 0;
  bottom: 0;
  max-width: 800px;
`

export const Wrapper = styled.section`
  position: relative;
  height: ${props => props.fillScreen ? '100vh' : '54rem'};
  overflow: hidden;
  min-height: 630px;
  background: black;

  ${BgImg} {
    min-height: ${props => props.fillScreen ? '100vh' : '54rem'};
    z-index: 0;
  }

  &:first-of-type {
    margin-top: ${props => props.isCarousel ? '0' : '-12rem'};
  }
`

export const BannerContent = styled.div`
  position: absolute;
  width: 100%;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
  z-index: 10;

  .inlineImage {
    margin: 60px auto;
    max-width: 170px;

    @media screen and (min-width: 768px) {
      margin: 0 auto;
      max-width: 220px;
      height: 100%;
    }

    @media screen and (min-width: ${props => props.theme.responsive.large}) {
      max-width: 300px;
    }
  }

  &.alignLeft {
    @media screen and (min-width: 768px) {
      display: flex;
      flex-direction: row-reverse;
      padding: 0 5rem;
    }
  
    @media screen and (min-width: 1024px) {
      align-items: center;
      max-width: 70%;
      padding: 0;
    }
  }
`

export const Title = styled.h2`
  text-transform: capitalize;
  font-weight: 200;
  padding: 0 1rem;
  color: ${props => props.theme.colors.white};
  line-height: 1.25;
  margin-bottom: 0;
`

export const Subtitle = styled.h5`
  text-align: center;
  color: ${props => props.theme.colors.white};

  &:before {
    content: '';
    display: block;
    margin: 3rem auto;
    height: 1px;
    max-width: ${props => props.theme.sizes.maxWidthTitleSmall};
    background-color: ${props => props.theme.colors.cobalt};
  }

  @media screen and (min-width: ${props => props.theme.responsive.medium}) {
    &:before {
      max-width: ${props => props.theme.sizes.maxWidthTitle};
    }
  }
`

export const Description = styled.div`
  text-align: center;
  color: ${props => props.theme.colors.white};
  padding: 0 2rem;
  margin: 0 auto;
  max-width: 38rem;

  &:before {
    content: '';
    display: block;
    margin: 3rem auto;
    height: 1px;
    max-width: 27rem;
    background-color: ${props => props.theme.colors.white};
  }

  a {
    color: ${props => props.theme.colors.cobalt};
  }

  @media screen and (min-width: ${props => props.theme.responsive.medium}) {
    padding: 0;
  }
`
